import React, { useId } from 'react';

/**
 * ArchImage — photo masked with a scalloped temple arch (mehrab) top edge,
 * with a thin saffron outline just outside the mask.
 */
const ARCH =
  'M0,1 L0,0.40 C0,0.35 0.02,0.32 0.05,0.32 C0.06,0.27 0.10,0.25 0.13,0.26 ' +
  'C0.15,0.21 0.19,0.19 0.22,0.20 C0.24,0.15 0.28,0.13 0.31,0.14 ' +
  'C0.33,0.09 0.37,0.07 0.40,0.08 C0.42,0.04 0.46,0.02 0.48,0.02 ' +
  'L0.50,0 L0.52,0.02 C0.54,0.02 0.58,0.04 0.60,0.08 C0.63,0.07 0.67,0.09 0.69,0.14 ' +
  'C0.72,0.13 0.76,0.15 0.78,0.20 C0.81,0.19 0.85,0.21 0.87,0.26 ' +
  'C0.90,0.25 0.94,0.27 0.95,0.32 C0.98,0.32 1,0.35 1,0.40 L1,1 Z';

export default function ArchImage({ src, alt = '', ratio = '4/3', className = '', outline = true, children }) {
  const id = `arch-${useId().replace(/[^a-zA-Z0-9]/g, '')}`;
  return (
    <div className={`arch${className ? ` ${className}` : ''}`} style={{ aspectRatio: ratio }}>
      <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
        <defs>
          <clipPath id={id} clipPathUnits="objectBoundingBox">
            <path d={ARCH} />
          </clipPath>
        </defs>
      </svg>
      {outline && <div className="arch__frame" style={{ clipPath: `url(#${id})` }} />}
      <div className="arch__inner" style={{ clipPath: `url(#${id})` }}>
        <img src={src} alt={alt} loading="eager" className="arch__img" />
        {children}
      </div>
    </div>
  );
}
